var _a;
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as actions from '../constants/actionTypes';
var zipCode = handleActions((_a = {},
    _a[actions.setZipCode.type.REQUEST] = function (_, _a) {
        var payload = _a.payload;
        return payload;
    },
    _a[actions.removeZipCode.type.REQUEST] = function () { return null; },
    _a), null);
export default combineReducers({
    zipCode: zipCode,
});
//# sourceMappingURL=registration.js.map